import React from 'react'
import styled from 'styled-components'

// styled components
const ListItem = styled.li`
  list-style: none;
  margin: 20px 0;
  display: inline-block;
`

const ItemLink = styled.a`
  display: inline-block;
  padding: 0 10px;
  margin: 0 14px;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  transition: all 0.2s ease-in-out 0.2s;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    background-color: #009DFE;
    padding: 0px 20px;
    color: white;
  }

  &:focus {
    text-decoration: none;
  }
`

const Filters = (props) => {
  return (
    <div className="categories-grid wow fadeInLeft">
      <nav className="categories">
        <ul className="portfolio_filter">
          {props.filters.map((item, index) => {
            return (
              <ListItem key={index}>
                <ItemLink
                  onClick={() => {
                    props.filterProjects(item.filter)
                  }}
                  className={item.isActive ? 'active' : 'inactive'}>
                  {item.name}
                </ItemLink>
              </ListItem>
            )
          })}
        </ul>
      </nav>
    </div>
  )
}

export default Filters
